import { loginUser, msalInstance, ensureInitialized } from '../auth.js';
import { useEffect, useState } from 'react';
import companyLogo from "../assets/2.png";

const loginRequest = {
  scopes: ['user.read', 'Mail.send', 'openid', 'profile', 'email']
};

const Login = ({ onLogin, onCancel }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;

    async function initAndCheckAccounts() {
      try {
        await ensureInitialized(); // 💥 Wait for MSAL init before calling any APIs
        if (!isMounted) return;

        const accounts = msalInstance.getAllAccounts();
        if (accounts.length === 0) {
          await msalInstance.logoutPopup().catch(() => { });
        }
      } catch (err) {
        console.error("MSAL init error:", err);
      }
    }

    initAndCheckAccounts();

    return () => {
      isMounted = false;
    };
  }, []);


  const handleLogin = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const user = await loginUser(loginRequest);
      onLogin(user);
    } catch (err) {
      console.error("Login failed:", err);
      if (err.errorCode === "user_cancelled") {
        onCancel();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center mt-6">
   
      <img
          src={companyLogo}
          alt="Company Logo"
          style={{ width: '200px', height: 'auto' }}
        />
        <h2 style={{ color: '#000000', fontWeight: 'bold', fontSize: '2.5rem' }}>AP Invoice Archive Login</h2>
        <p style={{ color: '#000000', fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '1rem' }}>Please log in using your Microsoft account</p>
      <button onClick={handleLogin} disabled={loading} style={{ padding: '1rem 4rem', fontSize: '1.2rem', backgroundColor: '#2A3990', color: 'white', border: 'none', borderRadius: '4px' }} onMouseEnter={(e) => (e.target.style.backgroundColor = '#83bfffff', e.target.style.color = '#000000ff')} onMouseLeave={(e) => (e.target.style.backgroundColor = '#2A3990', e.target.style.color = 'white')}>
        {loading ? 'Logging in…' : 'Login'}
      </button>
  </div>
  );
};

export default Login;
